module.exports = __webpack_public_path__ + "img/re.9623b3d9.png";